import { Autocomplete, TextField } from '@mui/material'
import { useTimezones } from '../hooks/useFleet'

interface Props {
  value: string
  onChange: (tz: string) => void
  label?: string
}

/**
 * Autocomplete dropdown over the canonical IANA timezone catalog (loaded from
 * docs/timezones.csv into the `timezones` table on every migrate run).
 */
export function TimezoneSelect({ value, onChange, label = 'Timezone' }: Props) {
  const { data: rows = [] } = useTimezones()
  const options = rows.map((r) => r.name)

  return (
    <Autocomplete
      options={options.length ? options : ['UTC']}
      value={value || 'UTC'}
      onChange={(_, v) => onChange(v ?? 'UTC')}
      disableClearable
      size="small"
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Search…" />
      )}
    />
  )
}
